'use strict';

import { contourDensity } from "d3";

 
let Configuration = {   
    m_BaseUrl: "https://localhost:54210" ,
  //  BaseUrl:"",

    get BaseUrl() {

        return this.m_BaseUrl;
    },

    
    set BaseUrl(val) {

        this.m_BaseUrl = val;
    }
}



export default Configuration;

